import React, { useState, useEffect } from "react";
import "./Header.scss";
import QatarLogo from "../../assets/images/qatar-airways-1 (1) 1.png";
import AboutQatarLogo from "../../assets/images/AboutPage.png";
import { Alert, Button, Dropdown, Menu } from "antd";
import { useNavigate, useLocation, Link } from "react-router-dom";
import WhatsappIcon from "../../assets/images/whatsapp-icon.png";
import { MenuOutlined } from "@ant-design/icons";
import NewsUpdate from "../NewsUpdate";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("hero-section");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Add smooth scrolling behavior to the entire document
    document.documentElement.style.scrollBehavior = "smooth";

    return () => {
      // Clean up the style when the component unmounts
      document.documentElement.style.scrollBehavior = "";
    };
  }, []);

  const isAuthRoute =
    location.pathname === "/login" || location.pathname === "/register";

  const getNavItems = () => {
    if (!isAuthRoute) {
      return [
        { id: "landing-page", label: "Home", href: "/" },
        {
          id: "about-us-section",
          label: "About",
          href: "aboutus",
        },
        // {
        //   id: "ask-query-section",
        //   label: "Ask a question",
        //   href: "#ask-query-section",
        // },
      ];
    } else if (isAuthRoute) {
      return [
        { id: "faq-section", label: "FAQ", href: "#faq-section" },
        { id: "help-section", label: "Help", href: "#help-section" },
      ]; // Empty nav for auth pages
    } else {
      return [
        { id: "faq-section", label: "FAQ", href: "#faq-section" },
        { id: "help-section", label: "Help", href: "#help-section" },
      ];
    }
  };
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId: string) => (e: React.MouseEvent) => {
    e.preventDefault();
  
    if (sectionId === "landing-page") {
      if (location.pathname !== "/") {
        navigate("/"); // redirect to home page
      } else {
        const section = document.getElementById("hero-section");
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }
      setActiveSection("hero-section");
      setIsMenuOpen(false);
      return;
    }
  
    if (sectionId === "about-us-section") {
      navigate("/aboutus");
      setActiveSection(sectionId);
      return;
    }
  
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setActiveSection(sectionId);
    }
  
    setIsMenuOpen(false); // Close mobile menu
  };
  

  const getLinkStyle = (sectionId: any) => ({
    color: activeSection === sectionId ? "var(--primary-color)" : "black",
    fontWeight: activeSection === sectionId ? "bold" : "normal",
  });

  const renderAuthButtons = () => {
    const buttonStyle = {
      transition: "all 0.3s ease",
      transform: "scale(1)",
      ":hover": {
        transform: "scale(1.05)",
      },
    };

    const primaryButtonStyle = {
      ...buttonStyle,
      backgroundColor: "var(--primary-color)",
    };

    const secondaryButtonStyle = {
      ...buttonStyle,
      color: "var(--primary-color)",
      borderColor: "var(--primary-color)",
    };

    if (location.pathname === "/login") {
      return (
        <Button
          type="primary"
          style={primaryButtonStyle}
          className="hover-scale-button"
          onClick={() => navigate("/register")}
        >
          Register Now
        </Button>
      );
    } else if (location.pathname === "/register") {
      return (
        <Button
          style={secondaryButtonStyle}
          className="hover-scale-button"
          onClick={() => navigate("/login")}
        >
          Log In
        </Button>
      );
    } else {
      return (
        <>
          <Button
            type="primary"
            shape="round"
            style={primaryButtonStyle}
            className="hover-scale-button"
            onClick={() => navigate("/register")}
          >
            Register Now
          </Button>
          <Button
            style={secondaryButtonStyle}
            shape="round"
            className="hover-scale-button"
            onClick={() => navigate("/login")}
          >
            Log In
          </Button>
        </>
      );
    }
  };

  const menu = (
    <Menu>
      {getNavItems().map((item) => (
        <Menu.Item key={item.id}>
          <a href={`${item.href}`} onClick={scrollToSection(item.id)}>
            {item.label}
          </a>
        </Menu.Item>
      ))}
      {location.pathname !== "/login" && (
        <Menu.Item key="register">
          <Button
            type="primary"
            style={{ backgroundColor: "var(--primary-color)", width: "100%" }}
            onClick={() => navigate("/register")}
          >
            Register Now
          </Button>
        </Menu.Item>
      )}
      {location.pathname !== "/register" && (
        <Menu.Item key="login">
          <Button
            style={{
              color: "var(--primary-color)",
              borderColor: "var(--primary-color)",
              width: "100%",
            }}
            onClick={() => navigate("/login")}
          >
            Log In
          </Button>
        </Menu.Item>
      )}
    </Menu>
  );
  const isAboutUs = location.pathname === "/aboutus"; // update this to your actual route path
  const isDashboard = location.pathname === "/dashboard";
  return (
    // <header className="header">
    <header
      className={`header ${
        location.pathname === "/aboutus" ? "black-header" : ""
      }`}
    >
      {/* <NewsUpdate /> */}

      <div className="header-container">
        {/* <div className="logo">
          <Link to="/">
            <img src={QatarLogo} alt="Qatar Airways" />
          </Link>
        </div> */}
        <div className="logo">
          <Link to="/">
            {isAboutUs ? (
              <img src={AboutQatarLogo} alt="About Qatar Airways" />
            ) : (
              <img src={QatarLogo} alt="Qatar Airways" />
            )}
          </Link>
        </div>
        <nav className="nav-menu desktop-menu">
          <ul>
            {getNavItems().map((item) => (
              <li key={item.id}>
                <a
                   href={item.id === "about-us-section" ? "#" : `#${item.id}`}
                    onClick={scrollToSection(item.id)}
                  style={{
                    ...getLinkStyle(item.id),
                    color: location.pathname === "/" ? "black" : "white",
                  }}
                  className={
                    location.pathname?.includes(item.href) ? "active" : ""
                  }
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div className="auth-buttons desktop-auth">
          {renderAuthButtons()}
          {/* <div className="whatsapp-icon">
            <img src={WhatsappIcon} alt="WhatsApp" />
          </div> */}
        </div>
        <div className="mobile-menu">
          <Dropdown
            overlay={menu}
            trigger={["click"]}
            visible={isMenuOpen}
            onVisibleChange={setIsMenuOpen}
          >
            <Button icon={<MenuOutlined />} onClick={toggleMenu} />
          </Dropdown>
        </div>
      </div>
    </header>
  );
}

export default Header;
